import Decimal from 'decimal.js';

import {
  EntityInEstateStatus,
  EntityKind,
  EntityStage,
  IncomeTaxPaymentConfigGrantorPaymentMethod,
  IncomeTaxPaymentConfigNonGrantorPaymentMethod,
  NonTrustEntityTaxStatus,
  TaxDragConfigCalculationMethod,
  TrustTaxStatus,
} from '@/types/schema';

export enum TaxDragBaseMode {
  Default = 'DEFAULT',
  Global = 'GLOBAL',
}

export interface TaxDragComputedInputs {
  federalIncomeTaxRate: Decimal | null;
  federalLongTermCapitalGainsRate: Decimal | null;
  stateIncomeTaxRate: Decimal | null;
  stateLongTermCapitalGainsRate: Decimal | null;
  niitEnabled: boolean;
  ordinaryIncomeReturnPercentage: Decimal | null;
  longTermCapitalGainReturnPercentage: Decimal | null;
  qualifiedDividendReturnPercentage: Decimal | null;
  taxFreeIncomeReturnPercentage: Decimal | null;
}

export interface TaxDragRateFormShape extends TaxDragComputedInputs {
  calculationMethod: TaxDragConfigCalculationMethod;
  taxDragPercentage: Decimal | null;
  // Keep the server result until the advisor changes its computation inputs.
  savedComputedRate?: {
    percentage: Decimal;
    inputs: TaxDragComputedInputs;
  };
}

export interface TaxDragOverrideFormShape extends TaxDragRateFormShape {
  id?: string;
  entityId: string;
}

export interface TaxDragFormShape {
  configId?: string;
  paymentConfigId?: string;
  baseMode: TaxDragBaseMode;
  globalRate: TaxDragRateFormShape;
  overrides: TaxDragOverrideFormShape[];
  grantorPaymentMethod: IncomeTaxPaymentConfigGrantorPaymentMethod;
  nonGrantorPaymentMethod: IncomeTaxPaymentConfigNonGrantorPaymentMethod;
  customPayerOrder: string[];
}

export interface TaxDragEntity {
  id: string;
  displayName: string;
  kind: EntityKind;
  stage: EntityStage;
  currentValue: Decimal;
  inEstateStatus?: EntityInEstateStatus | null;
  stateInEstateStatus?: EntityInEstateStatus | null;
  taxStatus?: NonTrustEntityTaxStatus | TrustTaxStatus | null;
}

export enum TaxDragEntityGroup {
  InEstate = 'In estate',
  OutOfEstate = 'Out of estate',
  Draft = 'Draft entities',
}

export interface StateTaxRates {
  income: Decimal | null;
  capitalGains: Decimal | null;
}
